// extracted by mini-css-extract-plugin
module.exports = {"navDropdownWrapper":"xc","navDropdownSide":"xd","navDropdownLink":"xe"};